/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function BellUnread({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M13.194 7.947c.049.2.115.396.199.585l1.03 2.318a1.6 1.6 0 0 1-1.462 2.25h-2.43a2.6 2.6 0 0 1-5.061 0H3.039a1.6 1.6 0 0 1-1.462-2.25l1.03-2.318a3.4 3.4 0 0 0 .293-1.38V6A5.1 5.1 0 0 1 8.785.96c-.24.35-.431.735-.565 1.146A3.9 3.9 0 0 0 4.1 6v1.151a4.6 4.6 0 0 1-.396 1.868l-1.03 2.319a.4.4 0 0 0 .365.562h9.922a.4.4 0 0 0 .366-.563l-1.03-2.318a4.597 4.597 0 0 1-.324-1.05 4.546 4.546 0 0 0 1.221-.022ZM8 13.9a1.4 1.4 0 0 1-1.265-.8h2.53A1.4 1.4 0 0 1 8 13.9Z" clipRule="evenodd" /><circle cx={12.5} cy={3.5} r={3.5} fill="var(--sp-color-action-bg-danger-default)" /></svg>;
}
;